"use strict";
import { makeStyles } from "@mui/styles";
import { theme } from "../../../../../ThemeContext/ThemeObject";
export default makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "31%",
    maxWidth: "31%",
    borderRadius: 6,
    marginBottom: 30,
    marginLeft: "1%",
    marginRight: "1%",
    boxShadow: "0px 0px 6px 0px rgba(0,0,0,0.16)",
    "&:hover": {
      cursor: "pointer",
      transform: "translateY(-2px)",
      boxShadow: "0px 0px 6px 2px rgba(0,0,0,0.16)"
    },
    "&:active": {
      transform: "translateY(-1px)",
      boxShadow: "0px 0px 6px 0px rgba(0,0,0,0.14)"
    }
  },
  content: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    padding: "40px 20px",
    alignItems: "flex-start",
    borderRadius: 6,
    borderTopWidth: 6,
    borderStyle: "solid",
    borderTopColor: "#DDD"
  },
  name: {
    fontSize: 21,
    color: "#000",
    userSelect: "none"
  },
  details: {
    color: "#939393",
    fontSize: 16,
    marginBottom: 8,
    userSelect: "none"
  },
  booking: {
    fontWeight: 600,
    color: `${theme.palette.secondary.main} !important`,
    fontSize: 14,
    userSelect: "none"
  },
  footer: {
    borderTop: "1px solid #DDDDDD",
    padding: "10px 26px",
    display: "flex",
    justifyContent: "space-between"
  },
  copyButton: {
    fontWeight: 400,
    fontSize: 10,
    padding: "4px 10px !important"
  },
  editButton: {
    fontWeight: 400,
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: 20,
    fontSize: 10,
    background: "#FFF",
    padding: "4px 10px !important"
  },
  shadow: {
    boxShadow: "rgb(0 0 0 / 55%) -4px -33px 15px -45px inset"
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%"
  },
  noEvents: {
    color: "#999",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1
  }
}));
